import { eDmCoSoActionsObj } from "../../action-types/category/IDmCoSoActions";
import { generateActions } from "../generateActions";

export const coSoActions = {
  ...generateActions(eDmCoSoActionsObj, "CO_SO"),
};
